import { z } from 'zod'

/**
 * Environment, validated once at module load.
 *
 * A missing Supabase URL should stop the app at boot with a sentence that says
 * what to do, not surface twenty minutes later as an unexplained empty list.
 *
 * Only `VITE_`-prefixed values exist here, and by definition every one of them
 * ships in the browser bundle. Nothing secret is ever allowed in this file —
 * the service role key, the Resend key and any third-party credential live in
 * edge function secrets and are read server side. If you find yourself wanting
 * to add one here, the answer is an edge function.
 */
const schema = z.object({
  VITE_SUPABASE_URL: z.string().url('VITE_SUPABASE_URL must be a full URL, e.g. https://xyz.supabase.co'),

  // The publishable (formerly anon) key. Safe in the bundle precisely because
  // every table has RLS on and no policy grants anything to an unauthenticated
  // caller.
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(20, 'VITE_SUPABASE_PUBLISHABLE_KEY looks truncated'),
})

const parsed = schema.safeParse(import.meta.env)

if (!parsed.success) {
  const problems = parsed.error.issues.map((issue) => `  ${issue.path.join('.')}: ${issue.message}`).join('\n')

  throw new Error(
    `The studio app is missing its configuration.\n\n${problems}\n\n` +
      'Copy studio/.env.example to studio/.env.local and fill it in, then restart the dev server.',
  )
}

export const env = parsed.data

/** True on a developer machine. Used to widen error output, never to weaken a check. */
export const isDev = import.meta.env.DEV
